<template>
	<v-app id="inspire">
		<!-- Top Navigation Bar -->
		<user-nav-menu user-type="LOCUM" :show-tabs="true" bg-color="#F6F6F6" :logo-file-name="tenant.settings.brandImages.headerLogos.app.dark"></user-nav-menu>

		<v-main>
			<v-banner v-show="warningBannerShowing" single-line color="#ff5f05" transition="scroll-y-transition">
				<v-avatar slot="icon" size="40">
					<v-icon icon="mdi-lock" color="white"> mdi-lock </v-icon>
				</v-avatar>
				{{ warningBannerMessage }}
			</v-banner>
			<v-container class fluid>
				<router-view />
				<!--slot / -->
			</v-container>
		</v-main>

		<v-footer app>
			<span>&copy; {{ new Date().getFullYear() }}</span>
		</v-footer>
	</v-app>
</template>

<script>
import UserNavMenu from '@/components/user/UserNavMenu';
import store from '@/store';
import { bus } from '@/main';

export default {
	name: 'LocumDashboardLayout',
	components: { UserNavMenu },
	data: () => ({
		warningBannerMessage: null,
		warningBannerShowing: false,
		demoIndustry: null,
	}),
	computed: {
		user: () => store.getters.user,
	},
	mounted() {
		bus.$on('locum-not-approved', message => {
			this.warningBannerShowing = true;
			this.warningBannerMessage = message;
			setTimeout(() => (this.warningBannerShowing = false), 5000);
		});
	},
};
</script>
